import { ReactNode } from 'react';

import config from 'config';
import Link from '@components/atoms/Link';
import Typography from '@components/atoms/Typography';
import HtmlPreview from '@components/HtmlPreview';
import getPlainText from 'utils/getPlainText';
import { FormattedMessage } from 'utils/intl';

import classes from './ProductName.module.scss';
import messages from './ProductName.messages';

const { routes } = config;

type Props = {
  title: string;
  productCode: string;
  producerPn?: string;
  manufacturer?: string;
  configurationCode?: string;
  withWordbreaks: boolean;
  children?: ReactNode;
};

const ProductName = ({
  title,
  productCode,
  producerPn,
  manufacturer,
  configurationCode,
  children,
  withWordbreaks,
}: Props): JSX.Element => (
  <div>
    <div className={classes.titleWrapper}>
      <Typography variant="h1" weight="400" className={classes.title} title={getPlainText(title)}>
        <HtmlPreview htmlText={title} withWordbreaks={withWordbreaks} />
      </Typography>
    </div>
    <div className={classes.info}>
      <FormattedMessage tagName="p" values={{ productCode }} {...messages.productCode} />
      {!!manufacturer && (
        <FormattedMessage
          tagName="p"
          values={{
            manufacturer: (
              <Link component="span" href={{ pathname: routes.search.href, query: { manufacturer } }} underline="hover">
                {manufacturer}
              </Link>
            ),
          }}
          {...messages.manufacturer}
        />
      )}
      {!!producerPn && <FormattedMessage tagName="p" values={{ producerPn }} {...messages.producerPn} />}
      {!!configurationCode && (
        <FormattedMessage tagName="p" values={{ configurationCode }} {...messages.configuration} />
      )}
      {children}
    </div>
  </div>
);

export default ProductName;
